import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  Modal,
  Box,
} from "@mui/material";
import heic2any from "heic2any";
import { Upload, X } from "lucide-react";
import React, { useEffect, useState } from "react";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import toast from "react-hot-toast";
import { getWorkorderImage } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import { FileText, FileVideo, FileImage, File } from "lucide-react";
import HeicPreview from "../../common/HeicPreview";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { LazyLoadImage } from "react-lazy-load-image-component";

const imagestyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 0,
  p: 2,
  overflowY: "auto",
};

const Workorderimages = ({
  selectedRow,
  VehicleDetail,
  // handleImageOpen,
  workOrderDetail,
  issueDetails,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const queryIssueid = new URLSearchParams(window.location.search).get(
    "issueId",
  );
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imageFor, setImageFor] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const [issueImagesList, setIssueImagesList] = useState(null);
  const [convertedUrl, setConvertedUrl] = useState(null);
  const [openImage, setOpenImage] = useState(false);
  const [imageSelection, setImageSelection] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);
  const [zoom, setZoom] = useState(1);

  const handleZoomIn = () => setZoom((prev) => Math.min(prev + 0.2, 3)); // max 3x
  const handleZoomOut = () => setZoom((prev) => Math.max(prev - 0.2, 0.5)); // min 0.5x

  const getImageUrl = (item) => {
    if (!item) return null;
    if (typeof item === "string") return item;
    return item?.url || item?.fileUrl || item?.path || null;
  };

  const handleImageClose = () => {
    setImageSelection(null);
    setOpenImage(false);
    setZoom(1);
    setCurrentIndex(0);
    setCurrentImages([]);
  };

  const handleImageOpen = (img, idx = 0, imagesArray = []) => {
    setImageSelection(getImageUrl(img));
    setCurrentIndex(idx);
    setCurrentImages(imagesArray);
    setOpenImage(true);
  };

  const handleNext = () => {
    if (!currentImages || currentImages.length === 0) return;
    if (currentIndex < currentImages.length - 1) {
      const newIndex = currentIndex + 1;
      const nextUrl = getImageUrl(currentImages[newIndex]);
      if (nextUrl) {
        setCurrentIndex(newIndex);
        setImageSelection(nextUrl);
      }
    }
  };

  const handlePrev = () => {
    if (!currentImages || currentImages.length === 0) return;
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      const prevUrl = getImageUrl(currentImages[newIndex]);
      if (prevUrl) {
        setCurrentIndex(newIndex);
        setImageSelection(prevUrl);
      }
    }
  };

  const getFileType = (url) => {
    if (!url) return "";

    const ext = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
    if (["mp4", "webm", "ogg"].includes(ext)) return "video";
    if (ext === "pdf") return "pdf";

    return "unknown";
  };

  const getIssueImageAPI = async (id) => {
    const apiDetails = await getWorkorderImage(id);
    const response = await commonapihandler(
      apiDetails?.apiUrl,
      apiDetails?.method,
    );
    if (response?.statusCode === "0100") {
      setIssueImagesList(response?.entities?.rows);
    }
  };

  useEffect(() => {
    if (selectedRow?.id || queryIssueid) {
      getIssueImageAPI(selectedRow?.id || queryIssueid);
    }
  }, [selectedRow?.id, queryIssueid]);

  /* Select images (no API call yet) */
  const handleSelectedFiles = (files) => {
    const fileArray = Array.from(files);
    setSelectedFiles((prev) => [...prev, ...fileArray]);
  };

  /* Remove selected image */
  const handleRemoveImage = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  /* Upload to API */
  const handleUpload = async () => {
    if (!selectedFiles.length) return;

    if (!imageFor) {
      return toast.error("Please Select the Image type Pre fix or Post fix", {
        position: "bottom-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "50px",
        },
      });
    }

    toast.loading("Image Upload Processing... Please wait", {
      id: "upload", // same ID to update later
      position: "top-center",
    });

    try {
      const res = await uploadmutiplefile(selectedFiles, "vehicles", "vehicle");
      setUploadedFiles(res?.uploaded);      
      await handleUploadAndSaveAPI(res?.uploaded);

      // Reset after upload
      setSelectedFiles([]);
    } catch (error) {
      console.error(error);
    }
  };

  const handleUploadAndSaveAPI = async (files) => {
    try {
      const response = await fetch(`${apiUrl}/api/workorderimages`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          workorderId: workOrderDetail?.id,
          vehicleId: workOrderDetail?.vehicleId,
          attachments: JSON.stringify(files),
          imageFor: imageFor,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.dismiss("upload");
        toast.success("Issues Image Uploaded Successfully.", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setSelectedFiles([]);
        setUploadedFiles(null);
        await getIssueImageAPI(selectedRow?.id);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  const normalizeAttachments = (attachments) => {
    if (!attachments) return [];

    // Case 1: attachments is a JSON string
    if (typeof attachments === "string") {
      try {
        const parsed = JSON.parse(attachments);
        return parsed.map((item) => item.url || item.fileUrl || item.path);
      } catch {
        return [];
      }
    }

    // Case 2: attachments is already an array
    if (Array.isArray(attachments)) {
      return attachments.map((item) => item.url || item.fileUrl || item.path);
    }

    // Case 3: attachments is a single object
    if (typeof attachments === "object") {
      if (attachments.uploaded) {
        return attachments.uploaded.map((item) => item.url);
      }
      return [attachments.url || attachments.fileUrl || attachments.path];
    }

    return [];
  };

  const safe = Array.isArray(issueImagesList) ? issueImagesList : [];

  const prefixImages = safe
    .filter(
      (item) =>
        item.imageFor?.toLowerCase() === "prefix" ||
        item.imageFor?.toLowerCase() === "prefixed",
    )
    .flatMap((item) => normalizeAttachments(item.attachments));

  const postFixImages = safe
    .filter((item) => item.imageFor?.toLowerCase() === "postfix")
    .flatMap((item) => normalizeAttachments(item.attachments));

  return (
    <>
      {openImage && (
        <Modal
          keepMounted
          open={openImage}
          onClose={handleImageClose}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box sx={imagestyle}>
            <div className="flex justify-between my-2">
              <a target="_blank" href={imageSelection} download={"image"}>
                <button class="cursor-pointer group relative flex gap-1.5 px-8 py-4 bg-black bg-opacity-80 text-[#f1f1f1] rounded-3xl hover:bg-opacity-70 transition font-semibold shadow-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    height="24px"
                    width="24px"
                  >
                    <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                    <g
                      stroke-linejoin="round"
                      stroke-linecap="round"
                      id="SVGRepo_tracerCarrier"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      {" "}
                      <g id="Interface / Download">
                        {" "}
                        <path
                          stroke-linejoin="round"
                          stroke-linecap="round"
                          stroke-width="2"
                          stroke="#f1f1f1"
                          d="M6 21H18M12 3V17M12 17L17 12M12 17L7 12"
                          id="Vector"
                        ></path>{" "}
                      </g>{" "}
                    </g>
                  </svg>
                  Download
                </button>
              </a>
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex justify-center gap-4 z-[9999]">
                <button
                  onClick={handleZoomIn}
                  className="px-4 py-2 bg-black text-white rounded-lg hover:bg-opacity-80"
                >
                  Zoom +
                </button>

                <button
                  onClick={handleZoomOut}
                  className="px-4 py-2 bg-black text-white rounded-lg hover:bg-opacity-80"
                >
                  Zoom -
                </button>
              </div>

              <button
                onClick={handleImageClose}
                className="ml-3 text-white bg-red-500 hover:bg-red-600 p-2 rounded-full w-10 h-10 flex items-center justify-center transition"
              >
                ✕
              </button>
            </div>
            <div className="relative flex justify-center mt-4">
              <button
                onClick={handlePrev}
                disabled={currentIndex === 0}
                className="absolute left-2 top-1/2 -translate-y-1/2 
                                     text-black p-3 rounded-full bg-white/80 
                                     hover:bg-blue-200 disabled:opacity-40 
                                     w-12 h-12 flex items-center justify-center shadow"
              >
                <KeyboardArrowLeftIcon className="w-6 h-6" />
              </button>
              {imageSelection &&
                (() => {
                  const type = getFileType(imageSelection);

                  if (type === "image") {
                    return (
                      <LazyLoadImage
                        src={imageSelection}
                        alt="attachment"
                        effect="blur"
                        placeholderSrc={imageSelection}
                        className="max-h-[70vh] object-contain transition-transform duration-200"
                        style={{ transform: `scale(${zoom})` }}
                      />
                    );
                  }

                  if (type === "video") {
                    return (
                      <video
                        src={imageSelection}
                        controls
                        className="max-h-[70vh] w-full object-contain"
                      />
                    );
                  }

                  if (type === "pdf") {
                    return (
                      <iframe
                        src={imageSelection}
                        title="PDF Viewer"
                        className="w-full h-[70vh]"
                      />
                    );
                  }

                  return <p>Unsupported file type</p>;
                })()}

              <button
                onClick={handleNext}
                disabled={currentIndex === currentImages.length - 1}
                className="absolute right-2 top-1/2 -translate-y-1/2 
                                     text-black p-3 rounded-full bg-white/80 
                                     hover:bg-blue-200 disabled:opacity-40 
                                     w-12 h-12 flex items-center justify-center shadow"
              >
                <KeyboardArrowRightIcon className="w-6 h-6" />
              </button>
            </div>
          </Box>
        </Modal>
      )}
      <div className="bg-white border rounded-2xl shadow-sm p-5 space-y-5">
        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-1">
            {/* Header */}
            <div>
              <h3 className="text-lg font-semibold text-gray-800">
                Upload Prefix or Postfix issue images
              </h3>
            </div>

            <div className="mt-4">
              <FormControl fullWidth size="small">
                <InputLabel>Image For</InputLabel>
                <Select
                  label="Image For"
                  value={imageFor}
                  sx={{ pt: 2 }}
                  onChange={(e) => setImageFor(e.target.value)}
                >
                  <MenuItem value="prefix">Pre Fix</MenuItem>
                  <MenuItem value="postfix">Post Fix</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>

          <div className="col-span-1">
            {/* Upload Input */}
            <div className="relative">
              <input
                type="file"
                id="issue-image-upload"
                multiple
                //   accept="image/*"
                className="hidden"
                onChange={(e) => handleSelectedFiles(e.target.files)}
              />

              <label
                htmlFor="issue-image-upload"
                className="flex flex-col items-center justify-center gap-2 border-2 border-dashed border-indigo-300 rounded-xl p-3 cursor-pointer hover:bg-indigo-50 transition"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-indigo-100">
                  <Upload size={22} className="text-indigo-600" />
                </div>

                <p className="text-sm font-medium text-gray-700">
                  Click to select images
                </p>
                <p className="text-xs text-gray-500">JPG, PNG up to 10MB</p>
              </label>
            </div>
          </div>
        </div>

        {selectedFiles.length > 0 && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
            {selectedFiles.map((file, index) => {
              const fileType = file.type;
              const fileFormat =
                file.name?.split(".").pop()?.toUpperCase() || "FILE";

              const renderPreview = () => {
                // 🖼 Image
                if (fileType.startsWith("image/")) {
                  return (
                    <img
                      src={URL.createObjectURL(file)}
                      alt="preview"
                      className="w-full h-32 object-cover rounded-lg border"
                    />
                  );
                }

                // 🎥 Video
                if (fileType.startsWith("video/")) {
                  return (
                    <video
                      src={URL.createObjectURL(file)}
                      className="w-full h-32 object-cover rounded-lg border"
                    />
                  );
                }

                // 📄 PDF
                if (fileType === "application/pdf") {
                  return (
                    <iframe
                      src={URL.createObjectURL(file)}
                      className="w-full h-32 rounded-lg border"
                      title="pdf-preview"
                    />
                  );
                }

                // 📁 Other files
                return (
                  <div className="w-full h-32 flex items-center justify-center rounded-lg border bg-gray-50">
                    <span className="text-sm font-semibold text-gray-600">
                      {fileFormat}
                    </span>
                  </div>
                );
              };

              return (
                <div key={index} className="relative group">
                  {renderPreview()}

                  {/* File info */}
                  <div className="mt-2 text-center">
                    <p className="text-sm font-medium truncate">{file.name}</p>
                    <p className="text-xs text-gray-500">{fileFormat}</p>
                  </div>

                  {/* Remove button */}
                  <button
                    onClick={() => handleRemoveImage(index)}
                    className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition"
                  >
                    <X size={14} />
                  </button>
                </div>
              );
            })}
          </div>
        )}

        <Button
          variant="contained"
          fullWidth
          disabled={!selectedFiles.length}
          onClick={handleUpload}
          sx={{ borderRadius: "12px", py: 1.2 }}
        >
          Upload Images
        </Button>

        <div className="p-6 bg-gray-50 rounded-2xl">
          <ImageGrid
            title="Prefix Images"
            images={prefixImages}
            handleImageOpen={handleImageOpen}
          />
          <ImageGrid
            title="Postfix Images"
            images={postFixImages}
            handleImageOpen={handleImageOpen}
          />
          <ImageGrid
            title="Cost Configuration Attachments"
            images={issueDetails?.costConfigAttachments}
            handleImageOpen={handleImageOpen}
          />
        </div>
      </div>
    </>
  );
};

export default Workorderimages;

const getFileType = (url = "") => {
  const ext = url.split(".").pop().toLowerCase();

  if (["jpg", "jpeg", "png", "webp", "gif", "avif", "svg"].includes(ext))
    return "image";
  if (["mp4", "webm", "ogg"].includes(ext)) return "video";
  if (ext === "pdf") return "pdf";
  if (ext === "heic") return "heic";
  if (["doc", "docx", "xls", "xlsx"].includes(ext)) return "doc";

  return "file";
};

const ImageGrid = ({ title, images, handleImageOpen }) => {
  if (!Array.isArray(images) || images.length === 0) return null;

  return (
    <div className="mb-8">
      <h2 className="text-lg font-semibold text-gray-800 mb-4">{title}</h2>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4">
        {images.map((item, index) => {
          const url = typeof item === "string" ? item : item?.url;
          if (!url) return null;

          const type = getFileType(url);

          return (
            <div
              key={index}
              className="border rounded-xl p-3 shadow hover:shadow-lg transition bg-white flex flex-col items-center justify-between gap-3"
            >
              {/* Preview */}
              <div
                onClick={() => {
                  handleImageOpen(url, index, images);
                }}
                className="flex items-center justify-center"
              >
                {type === "image" && (
                  <img
                    src={url}
                    alt={title}
                    className="w-28 h-24 object-cover rounded-lg cursor-pointer"
                  />
                )}

                {type === "heic" && (
                  <div>
                    <HeicPreview
                      url={url}
                      alt={title}
                      className="w-28 h-24 object-cover rounded-lg cursor-pointer"
                    />
                  </div>
                )}

                {type === "video" && (
                  <video src={url} controls className="w-28 h-24 rounded-lg" />
                )}

                {type === "pdf" && (
                  <FileText size={36} className="text-red-600" />
                )}

                {type === "doc" && <File size={36} className="text-blue-600" />}

                {type === "file" && (
                  <FileImage size={36} className="text-gray-600" />
                )}
              </div>

              <p>{item?.fileExt}</p>

              {/* Download Button */}
              <a
                href={url}
                target="_blank"
                download
                className="w-full text-center text-sm font-medium px-3 py-1.5 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-800 transition"
              >
                ⬇ Download
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};
